// @flow
import type { Element, Node } from 'React';

import React from 'react';
import { FormGroup } from 'reactstrap';
import { COMPONENT_FORM } from '@hbrisk/sp3-risk-model-support/components/form/name.js';
import { EnhancedFormGroup } from '#components/support/forms/utility/index.js';

type Props = {|
  children: Node,
  row?: boolean,
  check?: boolean,
  inline?: boolean,
  disabled?: boolean,
  tag?: string,
  className?: string,
  cssModule?: Object,
  fields?: Array<string>,
|};

/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
const ComponentFormGroup = ({
  children,
  row,
  check,
  inline,
  disabled,
  tag,
  className,
  cssModule,
  fields,
  ...rest
}: Props): Element<typeof FormGroup> => (
  <EnhancedFormGroup
    form={COMPONENT_FORM}
    fields={fields}
    row={row}
    check={check}
    inline={inline}
    disabled={disabled}
    tag={tag}
    className={className}
    cssModule={cssModule}
    {...rest}
  >
    {children}
  </EnhancedFormGroup>
);

export default ComponentFormGroup;
